import type { QuestionBoxVideoMentionData } from "@ui/organisms/QuestionBox/QuestionBoxVideoMention";
import { clipboardVideoMentions } from "./clipboardStore.ts";

/** The clipboard's video mentions in the shape the QuestionBox understands. */
export function clipboardQuestionBoxMentions(): QuestionBoxVideoMentionData[] {
	return clipboardVideoMentions().map((entity) => ({
		id: entity.data.video_id ?? entity.data.id,
		label: entity.data.title ?? `Video ${entity.data.index}`,
		thumbnailUrl: entity.data.thumbnail_url,
		startTimeSec: entity.data.start_time_sec,
		endTimeSec: entity.data.end_time_sec,
	}));
}
